import Button from "components/common/buttons/buttons";
import { CommentItem } from "pages/api/discuss/debate/[discussId]";
import { TYPO } from "styles/Typo";
import OptionBadge from "./OptionBadge";
import { useEffect, useRef, useState } from "react";
import { CommnetComponentsType } from "types/main";
import { useRouter } from "next/router";
import { useDebateCleanMode } from "states/debateState";

function DebateDesc({
  data,
  type,
}: {
  data: CommentItem;
  type: CommnetComponentsType;
}) {
  const isCleanMode = useDebateCleanMode();
  const [isOverflowing, setIsOverflowing] = useState(false);
  const textRef = useRef<HTMLParagraphElement>(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const [height, setHeight] = useState(0);
  const router = useRouter();
  const isOpinionDetailPage = router.pathname.startsWith(
    `/discuss/[slugId]/opinion`
  );

  useEffect(() => {
    if (!data) return;
    const el = textRef.current;
    if (el) {
      // 줄바꿈, 스타일 적용 이후 실제 높이 측정
      setIsOverflowing(el.scrollHeight > el.clientHeight);
      setHeight(el.scrollHeight);
    }
  }, [data]);

  return (
    <div
      className="flex flex-col gap-2"
      style={{
        wordBreak: "keep-all",
        wordWrap: "break-word",
        overflowWrap: "break-word",
        whiteSpace: "normal",
      }}
    >
      <OptionBadge data={data} />
      <p
        data-test-id={`debate-desc-${type}`}
        data-id={data?.comment_id}
        ref={textRef}
        className={`text-[16px] font-normal !tracking-[-0.16px] !leading-[24px] ${
          data?.isCensored && isCleanMode ? "text-gray50 italic" : "text-gray70"
        }  whitespace-pre-line ${
          isExpanded || isOpinionDetailPage
            ? `max-h-[${height}px]`
            : "max-h-[120px] oveflow-hidden line-clamp-5"
        }  
      
        `}
      >
        {data?.isCensored && isCleanMode
          ? `클린봇에 의해 가려진 ${data?.parent_id ? "댓글" : "의견"}입니다`
          : data?.description}
      </p>
      {isOverflowing && (
        <div
          data-test-id="debate-desc-more"
          className={isExpanded && type === "comment" ? "hidden" : "w-fit"}
        >
          <Button
            type="link_blue"
            size="md"
            text={"더보기"}
            clickHandler={() => {
              if (type === "comment") {
                // 댓글일 경우 실제로 height을 증가
                setIsExpanded(true);
              }
            }}
            btnClass="rounded-[10px]"
          />
        </div>
      )}
    </div>
  );
}

export default DebateDesc;
